<template>
  <div class="table-box">
    <mf-loading :loader="['last-update', 'primeiro-registro', 'produtos-mais-vendidos-top']" loader-type="table">
      <v-container fluid grid-list-md>
        <v-layout>
          <v-flex v-for="(card, index) in cards" :key="index" xs4>
            <cbm-card
              :number-text="card.value"
              :title="card.text"
              :loader="card.loader"
              use-loader
              :percent-text="card.underText"
              unset-percentage-colors
              simple-card
            />
          </v-flex>
        </v-layout>
      </v-container>
      <v-data-table :headers="headers" :items="dadosTabela" hide-default-footer disable-pagination @current-items="updateSelectedItems">
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.index }}</td>
            <td>
              <router-link class="link" :to="{ path: `/produtos/detalhes-produto/${item['COD_ID_PRODUTO']}` }">
                {{ item['COD_ID_PRODUTO'] }} - {{ item['DES_PRODUTO'] }}
              </router-link>
            </td>
            <td class="text-right">{{ item['NUM_CUPONS_TOTAL'] | localeString }}</td>
            <td class="text-right">{{ item['VAL_FATURAMENTO_TOTAL'] | localeString(2) | currency }}</td>
            <td class="text-right">{{ item['NUM_CLIENTES_TOTAL'] | localeString }}</td>
            <td class="text-right">{{ item['VAL_QUANTIDADE_KG_TOTAL'] | localeString(1) }}</td>
            <td class="text-right">{{ item['PORCENTAGEM'] | abreviation | percent }}</td>
          </tr>
        </template>
      </v-data-table>
    </mf-loading>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import { mapGetters } from 'vuex'
import { porcentagemProduto, localeString } from '@/config/helpers.js'
import { mapWaitingActions } from 'vue-wait'
import { productRanking } from '@/modules/produtos/ranking-produtos/mixins/productRanking'
import CbmCard from '@/components/CbmCard.vue'

export default {
  components: {
    CbmCard,
  },
  mixins: [productRanking],
  computed: {
    ...mapGetters(['produtosTopMaisVendidos', 'produtosTotalVendas', 'produtosTotalTopVendas', 'produtosSkuAtivasVendas']),
    dadosTabela() {
      return cloneDeep(this.produtosTopMaisVendidos).map((object, index) => {
        object['PORCENTAGEM'] = porcentagemProduto(object['VAL_QUANTIDADE_KG_TOTAL'], this.produtosTotalVendas)
        object.index = index + 1
        return object
      })
    },
    topVendasPorcentagem() {
      const value = this.produtosTotalTopVendas / this.produtosTotalVendas || 0
      return `${localeString(value * 100, 1)}%`
    },
    cards() {
      return [
        {
          text: 'Quantidade vendida',
          value: localeString(this.produtosTotalVendas || 0, 0),
          loader: 'totais-vendas-produtos',
          underText: '100%',
          isInteger: true,
        },
        {
          text: 'Quantidade vendida dos 100 itens com mais vendas',
          value: localeString(this.produtosTotalTopVendas || 0, 0),
          underText: this.topVendasPorcentagem,
          loader: 'totais-vendas-produtos-top',
          isInteger: true,
        },
        {
          text: 'Produtos distintos vendidos no período',
          value: localeString(this.produtosSkuAtivasVendas || 0, 0),
          loader: 'totais-vendas-produtos',
          isInteger: true,
        },
      ]
    },
  },
  methods: {
    ...mapWaitingActions({
      totaisVendasProdutos: 'totais-vendas-produtos',
      totaisVendasProdutosTop: 'totais-vendas-produtos-top',
      produtosMaisVendidosTop: 'produtos-mais-vendidos-top',
    }),
    internalGetData(filter) {
      return [this.totaisVendasProdutos(filter), this.totaisVendasProdutosTop(filter), this.produtosMaisVendidosTop(filter)]
    },
  },
}
</script>
